import "dotenv/config";
export default {
  API_END_POINT:
    process.env.NODE_ENV === "production"
      ? "https://apicrm.fanakfund.org/api/"
      : "http://localhost:3000/api/",
};
